import React from 'react';
import { useContext } from 'react';

import capitalise from '../../../utils/capitalise';
import { trackClickEventProp61 } from '../../../utils/omnitureUtils';
import { SEO_TRAIN_PAGE } from '../../../utils/RailsSEOConstants';
import { StationDetails } from '../../types';
import TrainInfoContext from '../TrainInfoContext';

const SEO_TRACKER_EVENT_NAME = 'rail_seo_train_stationseeonmap_clicked';

export type TrainStationAddressProps = {
  sourceStation: StationDetails;
  destinationStation: StationDetails;
};
export default function TrainStationAddress({ sourceStation, destinationStation }: TrainStationAddressProps) {
  const trainsData = useContext(TrainInfoContext);
  return (
    <section className="railSeoWrap__mapInfo--wrap">
      <h3 className="mobileShow font22 latoLight">{trainsData.miscellaneous['RAILWAY STATION ADDRESS']}</h3>
      <div className="railSeoWrap__mapInfo">
        <div>
          <h4 className="railSeoWrap__mapInfo--title">
            {capitalise(sourceStation.stationName)} ({sourceStation.stationCode})
          </h4>
          <p className="railSeoWrap__mapInfo--address">{sourceStation.address}</p>
        </div>
        <div className="makeFlex column perfectCenter">
          <span className="appendBottom10 mapIcon"></span>
          <a
            href={`https://www.google.com/maps/@${sourceStation.lat},${sourceStation.lng},20z`}
            target="_blank"
            rel="noopener noreferrer"
            className="font12 latoBold"
            onClick={() => trackClickEventProp61(SEO_TRAIN_PAGE, SEO_TRACKER_EVENT_NAME)}
          >
            {trainsData.miscellaneous['SEE ON MAP']}
          </a>
        </div>
      </div>
      <div className="railSeoWrap__mapInfo">
        <div>
          <h4 className="railSeoWrap__mapInfo--title">
            {capitalise(destinationStation.stationName)} ({destinationStation.stationCode})
          </h4>
          <p className="railSeoWrap__mapInfo--address">{destinationStation.address}</p>
        </div>
        <div className="makeFlex column perfectCenter">
          <span className="appendBottom10 mapIcon"></span>
          <a
            href={`https://www.google.com/maps/@${destinationStation.lat},${destinationStation.lng},20z`}
            target="_blank"
            rel="noopener noreferrer"
            className="font12 latoBold"
            onClick={() => trackClickEventProp61(SEO_TRAIN_PAGE, SEO_TRACKER_EVENT_NAME)}
          >
            {trainsData.miscellaneous['SEE ON MAP']}
          </a>
        </div>
      </div>
    </section>
  );
}
